export default __webpack_public_path__ + "static/media/cash.c8a88146.svg";